
import { areEntriesEqual } from 'src/app/core/entities/entry/infrastructure/utils/entry-processors.utils';
import { Payment } from 'src/app/core/entities/payment/domain/model/payment.model';
import { ITicketOperation } from 'src/app/core/entities/ticket/infrastructure/interfaces/ticket-storage.interface';
import { PAYMENT_FLOW } from 'src/app/core/enums/payment-flow.enum';
import { IOrganization } from 'src/app/core/entities/organization/domain/interfaces/organization.interface';
import {
  IPaymentDetails,
} from 'src/app/core/interfaces/payment.interface';
import { PAYMENT_METHOD } from 'src/app/shared/enums/payment-method.enum';
import { PAYMENT_TYPE } from 'src/app/shared/enums/payment-type.enum';

import { Drawer } from '@features/service/domain/models/drawer.model';
import { Worker } from '@features/service/domain/models/worker.model';

export function formatPaymentOperation(payment: Payment): ITicketOperation {
  const { payment_method, paymentResume, _id } = payment;

  return {
    amount: paymentResume?.totalAmount ?? 0,
    change: paymentResume?.changeDelivered ?? 0,
    payment_type: paymentResume?.paymentType,
    payment_method: payment_method ?? PAYMENT_METHOD.card,
    operation_id: _id,
  };
}

export function hasPaymentChanged(
  oldPayment: Payment,
  newPaymentInfo: {
    paymentDetails: IPaymentDetails;
    ticketSerie: string | undefined;
    currentDrawer: Drawer | null;
    currentWorker: Worker | null;
    organization: IOrganization | null;
    paymentFlow: PAYMENT_FLOW;
  }
): boolean {
  const {
    paymentDetails,
    ticketSerie,
    currentDrawer,
    organization,
  } = newPaymentInfo;

  const { paymentSummary } = paymentDetails;

  if (
    oldPayment.payment_method !== paymentSummary.paymentMethod ||
    oldPayment.payment_type !== paymentSummary.paymentType ||
    oldPayment.amount !== paymentSummary.totalAmount
  ) {
    return true;
  }

  if (
    oldPayment.cash_drawer_count_id !== '' ||
    oldPayment.cash_drawer_id !== currentDrawer?.id
  ) {
    return true;
  }

  if (
    oldPayment.divisa !== organization?.currency ||
    oldPayment.negocio_id !== organization?._id
  ) {
    return true;
  }

  if (
    !areEntriesEqual(oldPayment.entries, paymentDetails.entriesToPay) ||
    !areEntriesEqual(oldPayment.renderedEntries, paymentDetails.entriesRenderedAfterPayment)
  ) {
    return true;
  }

  const isProductPaymentNew =
    paymentSummary.paymentType === PAYMENT_TYPE.byProduct;

  if (oldPayment.isProductPayment !== isProductPaymentNew) {
    return true;
  }

  if (oldPayment.serie !== ticketSerie) {
    return true;
  }

  return false;
}
